import React from "react";
import { Panel } from "./primitives";

export default function Simple({ title, icon: Icon, text }) {
  return (
    <Panel title={title}>
      <div className="empty">
        <Icon size={52} />
        <h2>{title}</h2>
        <p>{text}</p>
      </div>
    </Panel>
  );
}
